export default [
    {
        path: "login/admin",
        name: "login.admin",
        component: "AdminLoginPage",
    },
    {
        path: "login/manager",
        name: "login.manager",
        component: "ManagerLoginPage",
    },
    {
        path: "login/space",
        name: "login.space",
        component: "spaceLoginPage",
    },
    {
        path: "password/reset",
        name: "password.request",
        component: "PasswordEmail",
    },
    {
        path: "password/reset/:token",
        name: "password.reset",
        component: "PasswordReset",
    },
]
